










import Vue, { PropOptions } from 'vue'
import { Subtab as SubtabProps } from '../interfaces'

export default Vue.extend({
  name: 'subtab',
  props: {
    subtab: {
      type: Object,
      default: () => null,
    } as PropOptions<SubtabProps>,
    isActive: {
      type: Boolean,
      default: () => false,
    },
    isDisabled: {
      type: Boolean,
      default: () => false,
    },
    subtabcolor: {
      type: String,
    },
  },
})
